import { useQuery } from "react-query";
import { ComparisonResponse } from "../types/responses/gradeComparisonResponse";
import DataRequest from "../queries/DataRequest";
import axios from "axios";

export const useGradingComparison = (inspectionId: string, user: any) => {
    return useQuery("comparison", async () => {
        const gradingData = await getGradeComparisonData(inspectionId, user);

        return gradingData;
    });
};

const getGradeComparisonData = async (
    inspectionId: string,
    user: any
): Promise<ComparisonResponse> => {
    const res = await DataRequest(inspectionId, "comparison", user);
    return res;
};

export const useScreeningGradingComparison = (imo: string, user: any) => {
    return useQuery("screeningcomparison", async () => {
        return await getScreeningGradeComparisonData(imo, user);
    });
};

const getScreeningGradeComparisonData = async (imo: string, user: any) => {
    const url = `${process.env.REACT_APP_IDWAL_API_URL}/Comparison/${imo}`;
    const token = user.signInUserSession.idToken.jwtToken;

    try {
        const response = await axios.get(url, {
            headers: {
                Authorization: "Bearer " + token
            }
        });

        return response.data;
    } catch (e) {
        console.log(e);

        return {};
    }
};
